import validate from 'validate.js'

const $submit = Array.prototype.slice.call(
  document.querySelectorAll(`[data-submit]`),
  0
)

// const regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

function requiredField(target) {
  // 2 Seconds
  const x = 2
  const $form = document.querySelector(`#${target}`)

  setTimeout(() => {
    const $requiredField = $form.querySelectorAll(`[data-required]`)
    const formError = $form.querySelector(`[data-form-errors]`)
    const formatError = $form.querySelector(`[data-format-error]`)
    const submitBtn = $form.querySelector(`[data-submit]`)
    const $submitBtn = $form.querySelector(`[type="submit"]`)
    const total = $requiredField.length
    let count = 0
    if ($requiredField && $requiredField.length > 0) {
      $requiredField.forEach($el => {
        if ($el.value != ``) {
          $el.classList.remove(`input-error`)
          if ($el.name == `email`) {
            const emailValue = $el.value
            const emailError = validate.single(emailValue, {
              presence: true,
              email: true
            })
            if (emailError) {
              $el.parentElement
                .querySelector(`.error`)
                .classList.remove(`hide`)
            } else {
              count = count + 1
              $el.parentElement.querySelector(`.error`).classList.add(`hide`)
            }
          } else if ($el.type == `select-one`) {
            count = count + 1
            $el.parentElement.classList.remove(`input-error`)
          } else {
            count += 1
          }
        } else {
          $el.classList.add(`input-error`)
          formError.classList.add(`hide`)
          if ($el.type == `select-one`) {
            $el.parentElement.classList.add(`input-error`)
          }
        }
      })
    }
    if (count == total) {
      formError.classList.add(`hide`)
      submitBtn.classList.add(`hide`)
      if ($submitBtn) {
        $submitBtn.classList.remove(`hide`)
      }
    } else {
      formError.classList.remove(`hide`)
      submitBtn.classList.remove(`hide`)
    }
    setTimeout(requiredField(target), x * 400)
  }, 400)
}

/**
 * Creating a New Honey Pot Validator
 * If the form has a field named "whatsyourage?" and that field contains a value then the submission will be rejected.
 * If the form has a field named "whatsyourage?" with no value set then the submission will succeed.
 */
function validateHoneyPot() {
  return new Promise((resolve, reject) => {
    const $honeyPot = document.getElementById(`sc-whatsyourage`)
    // If Honey Pot Exists Check it's value
    if ($honeyPot) {
      if ($honeyPot == null || $honeyPot.value == ``) {
        resolve()
      } else {
        reject()
      }
      // Else, allow other forms to process
    } else {
      resolve()
    }
  })
}

if ($submit.length > 0) {
  $submit.forEach($el => {
    const isCustomValidation =
      $el.closest(`form`) &&
      $el.closest(`form`).dataset &&
      $el.closest(`form`).dataset.customValidation
    if (isCustomValidation) {
      return
    }
    $el.addEventListener(`click`, async e => {
      e.preventDefault()
      const target = $el.dataset.submit
      const $target = document.getElementById(target)
      const $email = $target.querySelector(`input[name="email"]`)
      const $password = $target.querySelector(`input[type="password"]`)
      const $checkbox = $target.querySelector(`input[type="checkbox"]`)
      const $required = $target.querySelectorAll(`[data-required]`)
      const $submit = $target.querySelector(`[type="submit"]`)

      let error = 0

      // Check Honeypot
      try {
        await validateHoneyPot(e)
      } catch (e) {
        return
      }

      // Validate Fields
      requiredField(target)

      if ($required) {
        $required.forEach($element => {
          if ($element.value.trim() == ``) {
            error++
            $element.classList.add(`input-error`)
            $element.dataset.error
            if ($target.querySelector(`[data-form-errors]`)) {
              $target
                .querySelector(`[data-form-errors]`)
                .classList.remove(`hide`)
            }
          }
        })
      }

      if ($email) {
        const emailValue = $email.value
        const emailError = validate.single(emailValue, {
          presence: true,
          email: true
        })
        if ($email.value.trim() != ``) {
          const emailParentError = $email.parentElement.querySelector(`.error`)
          if (emailError && emailParentError) {
            error++
            emailParentError.classList.remove(`hide`)
          } else {
            emailParentError.classList.add(`hide`)
          }
          // $target.querySelector('[data-format-error]').classList.remove('hide');
        }
      }

      if (error < 1) {
        if ($checkbox) {
          if ($checkbox.checked) {
            if ($submit) {
              $submit.click()
            } else {
              $target.submit()
            }
          }
        } else {
          if ($submit) {
            $submit.click()
          } else {
            $target.submit()
          }
        }
      }
    })
  })
}
